<template>
  <div class="error-modal" v-if="visible">
    <div class="error-modal-overlay" @click="closeModal"></div>
    <div class="error-modal-container">
      <div class="error-modal-header">
        <h4>{{ title }}</h4>
        <button class="error-modal-close" @click="closeModal">×</button>
      </div>
      <div class="error-modal-content">
        <div class="error-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <p v-if="!allowHTML">{{ message }}</p>
        <p v-else v-html="message"></p>
      </div>
      <div class="error-modal-footer">
        <button class="btn error-modal-btn" @click="closeModal">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: '错误提示'
    },
    message: {
      type: String,
      default: ''
    },
    allowHTML: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.error-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000; /* 确保比主模态框层级高 */
}

.error-modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
}

.error-modal-container {
  background: white;
  width: 100%;
  max-width: 360px;
  border-radius: 12px;
  box-shadow: 0 15px 30px rgba(0,0,0,0.2);
  z-index: 1;
  position: relative;
  overflow: hidden;
  animation: errorModalAppear 0.3s ease;
  max-height: 80vh;
  overflow-y: auto;
}

@keyframes errorModalAppear {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.error-modal-header {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f1f1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(to right, #ff6b6b, #ef4444);
  color: white;
  min-height: 48px;
}

.error-modal-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: white;
  text-shadow: 0 1px 2px rgba(0,0,0,0.1);
  letter-spacing: 0.5px;
  line-height: 1.3;
  padding-right: 10px;
  width: calc(100% - 30px); /* 给关闭按钮留出空间 */
}

.error-modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: white;
  cursor: pointer;
  padding: 0;
  margin: 0;
  line-height: 1;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.error-modal-close:hover {
  opacity: 1;
}

.error-modal-content {
  padding: 16px;
  display: flex;
  align-items: flex-start;
}

.error-icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  color: #ef4444;
  flex-shrink: 0;
}

.error-icon svg {
  width: 100%;
  height: 100%;
}

.error-modal-content p {
  margin: 0;
  font-size: 14px;
  color: #374151;
  line-height: 1.5;
  flex: 1;
  word-break: break-word;
}

.error-modal-footer {
  padding: 12px 16px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #f1f1f1;
  background-color: #f9fafb;
}

.error-modal-btn {
  padding: 8px 18px;
  background: linear-gradient(135deg, #ff6b6b, #ef4444);
  border: none;
  border-radius: 6px;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
}

.error-modal-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

.error-modal-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(239, 68, 68, 0.3);
}

@media (max-width: 480px) {
  .error-modal-container {
    max-width: 90%;
    max-height: 70vh; /* 减小移动端显示高度 */
  }
  
  .error-modal-header h4 {
    font-size: 14px;
    padding-right: 5px; /* 防止与关闭按钮重叠 */
  }
  
  .error-modal-content p {
    font-size: 13px;
  }
  
  .error-icon {
    width: 18px;
    height: 18px;
    margin-right: 10px;
  }
  
  .error-modal-footer {
    padding: 10px 12px;
  }
  
  .error-modal-btn {
    padding: 8px 16px;
    width: auto; /* 防止按钮占满整个容器宽度 */
    min-width: 80px;
  }
}

/* 针对较小屏幕或横屏模式的优化 */
@media (max-height: 600px), (max-width: 380px) {
  .error-modal-container {
    max-height: 85vh;
  }
  
  .error-modal-header {
    padding: 10px 12px;
  }
  
  .error-modal-content {
    padding: 12px;
  }
}

.suggestion-list {
  margin: 8px 0 0 0;
  padding-left: 16px;
  text-align: left;
}

.suggestion-list li {
  margin-bottom: 5px;
  line-height: 1.4;
  font-size: 13px;
}

.suggestion-list li:last-child {
  margin-bottom: 0;
}
</style> 